module.exports = "/assets/data/847ef203b35b8a0cdefae80420ce82be-KT11.data.json";